const testimonials = [
  {
    name: 'Kathleen Hardman',
    role: 'Tenant',
    quote:
      'I was doing temporary accommodation staying in hotels. I came across an ad on gumtree arranged an appointment and was offered a room, it\'s reasonably priced, it\'s clean plus a cleaner comes regularly. The landlord has been a great help addressing any issues the tenants have immediately plus the house is in a great location close to busses and shops.',
    initials: 'KH',
  },
  {
    name: 'Paul Wakefield',
    role: 'Tenant',
    quote:
      'A big thank you for the great support over the past 6 months; it\'s been deeply appreciated; kind regards.',
    initials: 'PW',
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-navy-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-0.5 bg-gold-500" />
            <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">Tenant Reviews</span>
            <div className="w-8 h-0.5 bg-gold-500" />
          </div>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-white leading-tight">
            What Our Tenants Say
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-navy-800 rounded-lg p-8 border border-white/10 hover:border-gold-500/30 transition-all duration-200"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-gold-400 text-sm" />
                  </div>
                ))}
              </div>
              <p className="text-white/75 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-5 border-t border-white/10">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gold-500/20 text-gold-400 font-bold text-sm shrink-0">
                  {t.initials}
                </div>
                <div>
                  <p className="font-semibold text-white text-sm">{t.name}</p>
                  <p className="text-white/45 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
